module.exports = __webpack_public_path__ + "img/progress_049.067185e4.png";